import { render, staticRenderFns } from "./GraduatesSingleInitialCapabilities.vue?vue&type=template&id=03a4b828&"
import script from "./GraduatesSingleInitialCapabilities.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingleInitialCapabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports